import { combineReducers } from 'redux';
import clientReducer from './Clients/store/clientReducer';
import clientOrganizationalUnitReducer from './ClientOrganizational/store/clientOrganizationalUnitReducer';
import addressReducer from './Address/store/addressReducer';
import contactReducer from './Contact/store/contactReducer';
import projectReducer from './Projects/store/projectReducer';

export const reducers = combineReducers({
    clients: clientReducer,
    clientOrganizationalUnit: clientOrganizationalUnitReducer,
    address: addressReducer,
    contact: contactReducer,
    projects: projectReducer
});